import useApiRequest from 'api/useApiRequest';
import {
  uploadFiles,
  addUploadHubItem,
  fetchUploadHubList,
  updateUploadHubItem,
  deleteUploadHubItem,
  type UploadHubListItem,
} from 'api/services/uploadFileService';

export type { UploadHubListItem };

const useUploadFiles = () => {
  const { request } = useApiRequest();

  const uploadFile = async (params: Parameters<typeof uploadFiles>[1]) => {
    const { data } = await uploadFiles(request, params);
    return data;
  };

  const addItemToUploadHub = async (params: Parameters<typeof addUploadHubItem>[1]) => {
    const { data } = await addUploadHubItem(request, params);
    return data;
  };

  const uploadPendingFiles = async (pendingFiles: File[]): Promise<UploadHubListItem[]> => {
    const createdItems: UploadHubListItem[] = await addItemToUploadHub({ files: pendingFiles });
    return createdItems ?? [];
  };

  const getUploadHubList = async (params: Parameters<typeof fetchUploadHubList>[1]) => {
    const { data } = await fetchUploadHubList(request, params);
    return data;
  };

  const updateItemFromUploadHub = async (params: Parameters<typeof updateUploadHubItem>[1]) => {
    const { data } = await updateUploadHubItem(request, params);
    return data;
  };

  const deleteItemFromUploadHub = async (params: Parameters<typeof deleteUploadHubItem>[1]) => {
    const { data, status } = await deleteUploadHubItem(request, params);
    return { data, status };
  };

  return {
    uploadFile,
    addItemToUploadHub,
    uploadPendingFiles,
    getUploadHubList,
    updateItemFromUploadHub,
    deleteItemFromUploadHub,
  };
};

export default useUploadFiles;
